export const GET_MYDAY_TIMETABLE = 'my_timetable/GET_MYDAY_TIMETABLE';
export const GET_MYDAY_TIMETABLE_SUCCESS =
  'my_timetable/GET_MYDAY_TIMETABLE_SUCCESS';
